import React, { useState } from 'react';
import { X } from 'lucide-react';
interface APIFormProps {
  isOpen: boolean;
  onClose: () => void;
}
export function APIForm({
  isOpen,
  onClose
}: APIFormProps) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    useCase: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    console.log('API Integration Request:', formData);
    // In a real implementation, this would send data to a backend service
    // that would forward the information to ramzad@rawfounders.com
    alert('Thank you for your interest in our API! Your request has been sent to ramzad@rawfounders.com. Our technical team will contact you shortly.');
    // Reset form and close modal
    setFormData({
      name: '',
      email: '',
      company: '',
      useCase: '',
      message: ''
    });
    onClose();
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-96">
      <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto" data-id="element-97">
        <div className="p-6" data-id="element-98">
          <div className="flex justify-between items-center mb-4" data-id="element-99">
            <h2 className="text-2xl font-bold" data-id="element-100">API Integration Request</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-101">
              <X size={24} data-id="element-102" />
            </button>
          </div>
          <p className="text-gray-600 mb-6" data-id="element-103">
            Please fill out this form to connect with our technical team for API
            integration.
          </p>
          <form onSubmit={handleSubmit} data-id="element-104">
            <div className="space-y-4" data-id="element-105">
              <div data-id="element-106">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-107">
                  Full Name *
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-108" />
              </div>
              <div data-id="element-109">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-110">
                  Email Address *
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-111" />
              </div>
              <div data-id="element-112">
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-113">
                  Company Name *
                </label>
                <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-114" />
              </div>
              <div data-id="element-115">
                <label htmlFor="useCase" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-116">
                  Use Case *
                </label>
                <select id="useCase" name="useCase" value={formData.useCase} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-117">
                  <option value="" data-id="element-118">Select a use case</option>
                  <option value="agent-creation" data-id="element-119">Agent Creation</option>
                  <option value="data-integration" data-id="element-120">Data Integration</option>
                  <option value="workflow-automation" data-id="element-121">
                    Workflow Automation
                  </option>
                  <option value="custom-solution" data-id="element-122">Custom Solution</option>
                  <option value="other" data-id="element-123">Other</option>
                </select>
              </div>
              <div data-id="element-124">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-125">
                  Additional Details *
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-126"></textarea>
              </div>
              <div data-id="element-127">
                <button type="submit" className="w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors" data-id="element-128">
                  Submit Request
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>;
}